var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF7ArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2323_25502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98455 11.8106C4.20022 12.0263 4.50675 12.0344 4.72224 11.8189L10.1788 6.36237L11.028 5.44666L10.908 8.0444L10.9246 9.91717C10.9246 10.0498 10.9907 10.1823 11.086 10.2776C11.2932 10.4848 11.604 10.4809 11.8073 10.2776C11.9066 10.1783 11.9561 10.0538 11.9604 9.89224L11.9648 4.38618C11.9687 4.2246 11.9149 4.08778 11.8115 3.98436C11.712 3.88484 11.5752 3.8311 11.4136 3.83499L5.90735 3.83923C5.7456 3.84365 5.6215 3.89315 5.52198 3.99267C5.31904 4.19561 5.31479 4.50639 5.51773 4.70933C5.61726 4.80885 5.74984 4.87497 5.88242 4.87497L7.75095 4.88734L10.357 4.76749L9.43723 5.62079L3.98066 11.0774C3.76517 11.2928 3.76906 11.5951 3.98455 11.8106Z",
    fill: "#0084FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2323_25502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.899414 0.899414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF7ArrowUp);
export default __webpack_public_path__ + "static/media/f7_arrow-up.bc5020544bc5e47cb576a5d09e455e4f.svg";
export { ForwardRef as ReactComponent };